
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("hBGZx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $cd173d93dc9d9796$var$_jquery = $cd173d93dc9d9796$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $cd173d93dc9d9796$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// ====================================================================================
// readMoreMarker.module
// ====================================================================================
var $cd173d93dc9d9796$var$init = module.exports.init = function init() {
    // read-more Klapperfunktion mit ###weiterlesen### marker
    var $readMore = (0, $cd173d93dc9d9796$var$_jquery["default"])(".read-more-marker");
    if ($readMore.length) $readMore.each(function() {
        var $readMoreMarker = (0, $cd173d93dc9d9796$var$_jquery["default"])(this);
        var $readMoreText = $readMoreMarker.nextAll();
        $readMoreMarker.html('<button class="btn btn--read btn--read-more p-0" type="button">\n            <span>... weiterlesen</span>\n    </button>');
        $readMoreText.hide();
        $readMoreMarker.parent().append('<div class="read-less-marker">\n    <button class="btn btn--read btn--read-less p-0" type="button">\n            <span>weniger lesen</span>\n    </button>\n</div>');
        $readMoreMarker.parent().find(".read-less-marker").hide();
        //$('.read-more').parent().nextAll().css( "background-color", "red" );
        $readMoreMarker.click(function() {
            $readMoreText.slideDown();
            (0, $cd173d93dc9d9796$var$_jquery["default"])(this).hide();
            (0, $cd173d93dc9d9796$var$_jquery["default"])(this).parent().parent().find(".read-less-marker").show();
        });
        $readMoreMarker.parent().parent().find(".read-less-marker").click(function() {
            $readMoreText.slideUp();
            (0, $cd173d93dc9d9796$var$_jquery["default"])(this).hide();
            (0, $cd173d93dc9d9796$var$_jquery["default"])(this).parent().parent().find(".read-more-marker").show();
        });
    });
};

});


//# sourceMappingURL=readMoreMarker.module.c78fa6b1.js.map
